/** @jsx jsx */
import { Fragment } from "react"
import { jsx } from "theme-ui"

import { vwoService } from "@trueskin-web/services"

import fileSvg from "./fileIcon.svg"

export const fileIcon = vwoService.isThemeRebrandedEnabled()
  ? fileSvg
  : {
      path: (
        <Fragment>
          <path
            d="M4 2h10l6 6v14H4V2z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M14 2v6h6"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M16 13H8M16 17H8M10 9H8"
            stroke="currentColor"
            strokeLinecap="square"
            strokeLinejoin="round"
            fill="none"
          />
        </Fragment>
      ),
    }
